import React from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import BarChartIcon from '@mui/icons-material/BarChart';
import SettingsIcon from '@mui/icons-material/Settings';
import LabelIcon from '@mui/icons-material/Label';
import { Option } from '@components/SideBar/interfaces';

export const newsMenuOptions: Option[] = [
  {
    key: 'overview',
    link: '/manage/news/overview',
    icon: <VisibilityIcon />,
    inProduction: true,
  },
  {
    key: 'stats',
    link: '/manage/news/stats',
    icon: <BarChartIcon />,
  },
  {
    key: 'categories',
    link: '/manage/news/categories',
    icon: <LabelIcon />,
  },
  {
    key: 'settings',
    link: '/manage/news/settings',
    icon: <SettingsIcon />,
  },
];
